import {Injectable} from '@angular/core';
import {Recipe} from "./dtos/recipe";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {RecipePart} from "./dtos/recipePart";
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {filter, map, tap} from "rxjs/operators";
import { Timestamp } from '@firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class RecipeService {

  private recipes: Recipe[] = [];
  private list: BehaviorSubject<Recipe[]> = new BehaviorSubject(null);
  private list$: Observable<Recipe[]> = this.list.asObservable();

  constructor(
    private db: AngularFirestore
  ) {
    var recipeCollection = db.collection('recipes');
    const recipesFromLocalStorage: string = localStorage.getItem('recipeList');
    if (recipesFromLocalStorage != null) {
      const localRecipes: Recipe[] = JSON.parse(recipesFromLocalStorage);
      localRecipes.forEach(rec => {
        if (rec.creationDate != undefined) {
          const seconds = rec.creationDate.seconds;
          if (!(rec.creationDate instanceof Timestamp)) {
            rec.creationDate = Timestamp.fromMillis(seconds * 1000);
          }
        }
      });
      this.list.next(localRecipes);
    }
    recipeCollection.stateChanges(['added', 'modified']).pipe(
      map(value => {
        var addCount: number = 0;
        var changeCount: number = 0;
        const observableList: Observable<Recipe>[] = [];
        value.forEach(val => {
          const recipe: Recipe = new Recipe(val.payload.doc.data());
          recipe.id = val.payload.doc.id;
          if (val.type == "added")
            addCount++;
          else
            changeCount++;
          observableList.push(this.fetchFullRecipe(recipe));
        });
        console.log(`adding ${addCount} recipes`);
        console.log(`modifying ${changeCount} recipes`);
        combineLatest(observableList).subscribe(recs => {
          recs.map(rec => {
            const index = this.recipes.findIndex(recipe => recipe.id == rec.id);
            if (index == -1) {
              this.recipes.push(rec);
            } else {
              this.recipes[index] = rec;
            }
          });
          this.list.next(this.recipes);
        });
      })
    ).subscribe();

    recipeCollection.stateChanges(["removed"]).pipe(
      map(value => {
        value.forEach(val => {
          this.recipes = this.recipes.filter(recipe => recipe.id != val.payload.doc.id);
        });
        this.list.next(this.recipes);
      })
    ).subscribe();

    this.list$.pipe(
      tap(v => {
        if (v != null) {
          localStorage.setItem('recipeList', JSON.stringify(v));
        }
      })
    ).subscribe()
  }

  private fetchFullRecipe(recipe: Recipe): Observable<Recipe> {
    return this.db.collection('recipes').doc(recipe.id).collection('tasks').snapshotChanges().pipe(
      map(actions => {
          recipe.parts = actions.map(a => {
            const part = a.payload.doc.data() as RecipePart;
            part.id = a.payload.doc.data()['id'];
            return part;
          });
          return recipe;
        }
      )
    );
  }

  getRecipes(): Observable<Recipe[]> {
    return this.list$;
  }

  getRecipe(id: string): Observable<Recipe> {
    return this.list$.pipe(
      filter(recipes => recipes != null),
      map(recipes => recipes.find(recipe => recipe.id == id))
    );
  }

}
